import Styles from './Label.module.scss'
import cx from 'classnames'
import { LabelProps } from './Types'

const Label = ({ label, classNames }: LabelProps) => {
  return (
    <div className={cx(Styles.label, classNames)} title={label}>
      {label}
    </div>
  )
}

export { Label }
